import { Dropdown, Menu, MenuButton, MenuItem } from '@mui/joy';
import { CaretDown } from '@phosphor-icons/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Color, Size, Variant } from 'theme/enums';

import { GLOBAL_SEARCH_SELECTOR_WIDTH } from './constants';
import { SearchScope } from './enums';

interface IProps {
  value: SearchScope;
  onChange: (scope: SearchScope) => void;
}

const SCOPE_LABEL_KEYS: Record<SearchScope, string> = {
  [SearchScope.PARTS]: 'labelScopeParts',
  [SearchScope.VENDORS]: 'labelScopeVendors',
};

export const SearchScopeSelector = ({ value, onChange }: IProps) => {
  const { t } = useTranslation();

  const menuItems = useMemo(
    () =>
      Object.values(SearchScope).map((scope) => ({
        key: scope,
        label: t(SCOPE_LABEL_KEYS[scope]),
        selected: scope === value,
        onClick: () => onChange(scope),
      })),
    [value, onChange, t]
  );

  return (
    <Dropdown>
      <MenuButton
        size={Size.SM}
        variant={Variant.SOFT}
        color={Color.NEUTRAL}
        endDecorator={<CaretDown weight="fill" />}
        sx={{
          borderRadius: '0',
          borderBottomLeftRadius: '2px',
          borderTopLeftRadius: '2px',
          borderRight: '1px solid',
          borderColor: 'neutral.300',
          fontWeight: 600,
          minWidth: GLOBAL_SEARCH_SELECTOR_WIDTH,
          minHeight: 32,
          px: 1.5,
          flexShrink: 0,
          whiteSpace: 'nowrap',
        }}
      >
        {t(SCOPE_LABEL_KEYS[value])}
      </MenuButton>
      <Menu
        placement="bottom-start"
        size={Size.SM}
        sx={{ zIndex: (theme) => theme.vars.zIndex.modal, minWidth: 120 }}
      >
        {menuItems.map((item) => (
          <MenuItem key={item.key} selected={item.selected} onClick={item.onClick}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
};
